"use client";

import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

interface Logo {
  name: string;
  src: string;
}

const LOGOS: Logo[] = [
  { name: "Salty Zebra", src: "/images/brand-logo2.png" },
  { name: "Bram Sturm", src: "/images/brand-logo3.png" },
  { name: "Twelvef Moments", src: "/images/brand-logo4.png" }
];

export function LogoMarquee() {
  const { isDark } = useTheme();
  const list = [...LOGOS, ...LOGOS]; // duplicate for seamless loop

  return (
    <div className="relative w-full overflow-hidden">
      {/* fade edges */}
      <div
        className={cn(
          "pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r to-transparent",
          isDark ? "from-[#07070B]" : "from-[#FAFAF9]"
        )}
      />
      <div
        className={cn(
          "pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l to-transparent",
          isDark ? "from-[#07070B]" : "from-[#FAFAF9]"
        )}
      />

      <div className="flex w-max marquee">
        {list.map((logo, i) => (
          <div
            key={`${logo.name}-${i}`}
            className="flex items-center gap-3 mx-8 sm:mx-12 group"
          >
            <img
              src={logo.src}
              alt={logo.name}
              className={cn(
                "h-7 sm:h-8 w-auto transition-opacity",
                isDark
                  ? "opacity-50 group-hover:opacity-90"
                  : "opacity-60 group-hover:opacity-100"
              )}
            />
            <span
              className={cn(
                "text-sm font-medium tracking-tight transition-colors",
                isDark
                  ? "text-white/40 group-hover:text-white/80"
                  : "text-stone-500 group-hover:text-stone-900"
              )}
            >
              {logo.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
